/**
 * The client's own brief for one cart line.
 *
 * Offered on the ONE surface {@link productCommentSurface} names — the drawer for
 * a product with no configuration page, the editing page for one that has it,
 * because a brief describes the visuals handed over there. Either way it ends up
 * on `CartItem.note`, which `serializePlacement` sends as `products[i].comment`;
 * v2 carries one comment PER LINE, so unlike legacy nothing has to concatenate
 * them into the order-level comment.
 *
 * Copy is legacy's (`order:step_product.editing_product_comments_*`), already
 * translated in all six locales, so this adds no new keys. `_header` is the
 * title ("Comments") and `_label` the instruction beneath it — legacy swapped
 * between them by edit/read-only state, which the drawer has no equivalent of.
 * `_placeholder` is deliberately unused: it is EMPTY in every locale.
 */

import React from 'react'
import { useTranslation } from 'react-i18next'

import { MUIInputField } from 'components/common/MUIInputField'

import { DrawerSection } from './DrawerSection.component'

interface Props {
  value: string
  onChange: (next: string) => void
  /** Last section in the drawer ⇒ it carries the beige terminal treatment. */
  isLast?: boolean
  /** Drop the drawer's own panel chrome, for a host that already owns its spacing. */
  plain?: boolean
}

export const ProductCommentSection: React.FC<Props> = ({ value, onChange, isLast = false, plain = false }) => {
  const { t } = useTranslation(['order'])

  return (
    <DrawerSection
      title={t('order:step_product.editing_product_comments_header')}
      subtitle={t('order:step_product.editing_product_comments_label')}
      isLast={isLast}
      plain={plain}
      gap={plain ? 1.2 : 2.4}
    >
      <MUIInputField
        isMultiline
        inputBoxHeight="8rem"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
    </DrawerSection>
  )
}
